<div class="component-viewer">
    <mat-card>
        <mat-card-header style="display: inline;">
            <div class="row w-100">
                <div class="col-6 text-start">
                    <h2 class="mb-0">Promo Codes</h2>
                </div>
                <div class="col-6 text-end">
                    <button mat-raised-button (click)="createPromoCode()">Add <mat-icon>add</mat-icon></button>
                </div>
            </div>
        </mat-card-header>
        <mat-card-content>
            <gt-table *ngIf="true" [loading]="isLoading" [defaultPageSize]="15" [updateFilterEvent]="updateFilterEvent"
            [filter]="filter" [data]="promoCodes" (filterChanged)="getPromoCodes()" (filterReset)="resetFilter()">
        </gt-table>
        <mat-progress-bar mode="indeterminate" *ngIf="isLoading"></mat-progress-bar>
            <table mat-table [dataSource]="promoCodes" matSort (matSortChange)="sortData($event)">
                <ng-container matColumnDef="code">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header="code">Code</th>
                    <td mat-cell *matCellDef="let promo">{{promo.code}}</td>
                </ng-container>

                <ng-container matColumnDef="discountType">
                    <th mat-header-cell *matHeaderCellDef>Type</th>
                    <td mat-cell *matCellDef="let promo">
                        {{promo.discountType === DiscountType.Percentage ? 'Percentage' : 'Fixed Amount'}}
                    </td>
                </ng-container>

                <ng-container matColumnDef="discountAmount">
                    <th mat-header-cell *matHeaderCellDef>Amount</th>
                    <td mat-cell *matCellDef="let promo">
                        {{promo.discountType === DiscountType.Percentage ? promo.discountAmount + '%' : '$' + promo.discountAmount}}
                    </td>
                </ng-container>

                <ng-container matColumnDef="startDate">
                    <th mat-header-cell *matHeaderCellDef>Start Date</th>
                    <td mat-cell *matCellDef="let promo">{{promo.startDate | date:'MM/dd/yyyy'}}</td>
                </ng-container>

                <ng-container matColumnDef="endDate">
                    <th mat-header-cell *matHeaderCellDef>End Date</th>
                    <td mat-cell *matCellDef="let promo">{{promo.endDate | date:'MM/dd/yyyy'}}</td>
                </ng-container>

                <ng-container matColumnDef="usageLimit">
                    <th mat-header-cell *matHeaderCellDef>Usage Limit</th>
                    <td mat-cell *matCellDef="let promo">
                        <ng-container *ngIf="promo.usageLimit === 0"><mat-icon>all_inclusive</mat-icon></ng-container>
                        <ng-container *ngIf="promo.usageLimit > 0">
                            {{promo.usageLimit}}
                        </ng-container>
                    </td>
                </ng-container>

                <ng-container matColumnDef="currentUsageCount">
                    <th mat-header-cell *matHeaderCellDef>Times Used</th>
                    <td mat-cell *matCellDef="let promo">{{promo.currentUsageCount}}</td>
                </ng-container>

                <ng-container matColumnDef="isActive">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header="isActive"> Active </th>
                    <td mat-cell *matCellDef="let promo">
                        <section>
                            <mat-slide-toggle
                                [checked]="promo.isActive"
                                (change)="toggleStatus(promo, $event.checked)">
                                <ng-container *ngIf="promo.isAvailable">Yes</ng-container>
                                <ng-container *ngIf="!promo.isAvailable">No</ng-container>
                            </mat-slide-toggle>
                        </section>
                    </td>
                </ng-container>

                <ng-container matColumnDef="actions">
                    <th mat-header-cell *matHeaderCellDef>Actions</th>
                    <td mat-cell *matCellDef="let promo">
                        <button mat-icon-button [matMenuTriggerFor]="menu">
                            <mat-icon>more_vert</mat-icon>
                        </button>
                        <mat-menu #menu="matMenu">
                            <button mat-menu-item (click)="editPromoCode(promo)">
                                <mat-icon>edit</mat-icon>
                                <span>Edit</span>
                            </button>
                            <button mat-menu-item (click)="deletePromoCode(promo)">
                                <mat-icon>delete</mat-icon>
                                <span>Delete</span>
                            </button>
                        </mat-menu>
                    </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
            </table>
        </mat-card-content>
    </mat-card>
</div>
